"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRChannelWatch = void 0;
const watch_1 = require("../watch");
class SSRChannelWatch extends watch_1.ChannelWatch {
    watching = (name) => {
        if (name) {
            return true;
        }
        return this.watched.slice();
    };
}
exports.SSRChannelWatch = SSRChannelWatch;
//# sourceMappingURL=watch.js.map